import { css } from "@emotion/css";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const detailsControlStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const lastDetailsControlStyle = css`
    flex: 1 1;

    padding-bottom: 0;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;
